import dayjs from 'dayjs';

const NUMBER_TO_DAY_MAP: Record<string, string> = {
  0: 'א',
  1: 'ב',
  2: 'ג',
  3: 'ד',
  4: 'ה',
  5: 'ו',
  6: 'ש',
};
export function dateDifferenceInDays(startDate: Date, endDate: Date): number {
  const dayInMilliseconds = 1000 * 60 * 60 * 24;
  const diffInMilliseconds = endDate.getTime() - startDate.getTime();
  return Math.floor(diffInMilliseconds / dayInMilliseconds) + 1;
}

export function formatLocaleDate(date: Date): string {
  const dateFormat: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'numeric',
    day: 'numeric',
  };
  return new Intl.DateTimeFormat('he-IL', dateFormat).format(date);
}

export function enumerateDaysBetweenDates(startDate: Date, endDate: Date): Date[] {
  const dates: Date[] = [];
  let currDate = startDate;
  while (dayjs(currDate) <= dayjs(endDate)) {
    dates.push(currDate);
    currDate = dayjs(currDate).add(1, 'day').toDate();
  }
  return dates;
}

export function getShortDateWithoutYear(date: Date): string {
  return dayjs(date).format('D.M');
}

export function getHebrewDayOfWeek(date: Date): string {
  const dayNumber = dayjs(date).day();
  const hebrewDay = NUMBER_TO_DAY_MAP[dayNumber];
  if (!hebrewDay) {
    throw new Error(`no mapping for hebrew day for day number ${dayNumber}`);
  }
  return hebrewDay;
}
